import type { CSSProperties } from 'react';

/**
 * Layer Lab "Picto" glyphs (white PNGs in /public/icons) rendered through a CSS
 * mask, so they take the current text colour: pink when a tab is active,
 * muted when not, white on buttons.
 */
export type IconName =
  | 'search' | 'feed' | 'activity' | 'messages' | 'profile' | 'settings' | 'back' | 'thumbs' | 'jam' | 'send'
  | 'follow' | 'check' | 'camera' | 'video' | 'mic' | 'play' | 'pin' | 'plus' | 'close' | 'star' | 'photo' | 'lock';

export function Icon({ name, size = 22, className = '', style }: { name: IconName; size?: number; className?: string; style?: CSSProperties }) {
  const url = `url(/icons/${name}.png)`;
  return (
    <span aria-hidden="true" className={`icon ${className}`}
      style={{ width: size, height: size, WebkitMaskImage: url, maskImage: url, ...style }} />
  );
}
